export class Alert {
    type?: AlertType;
    message?: string;
    additionalMessage?: string;
    rootCauseMessage?: string;
    rootCauseStacktrace?: string[];
    requestId?: string;
    cssClass?: string;
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning,
    Message
}
